import { Badge, Box, Divider, NavLink } from '@mantine/core';
import { useEffect, useState } from 'react';
import TransactionAdapter from '../adapters/transactionAdapter';
import docStatusMap from '../constants/docStatusMap';

const hideDocCountsFrom = ['DASHBOARD'];

function NavBarItems({ setView, navbarData, activeTabIndex = 0 }) {
  const [active, setActive] = useState(activeTabIndex);
  const [queueCount, setQueueCount] = useState([]);

  useEffect(() => {
    setActive(activeTabIndex);
  }, [activeTabIndex]);

  useEffect(() => {
    fetchQueueCount();
  }, []);

  // Add event listener to update queue counts when bookmarks change
  useEffect(() => {
    const controller = new AbortController();

    window.addEventListener('bookmarkChanged', fetchQueueCount, {
      signal: controller.signal,
    });

    return () => {
      controller.abort();
    };
  }, []);

  const fetchQueueCount = async () => {
    // Initiate both requests in parallel instead of waiting for each sequentially
    // This allows both network requests to run simultaneously, improving performance
    const queueCountPromise = TransactionAdapter.getTransactionsCount();
    const bookmarkedDocsPromise = TransactionAdapter.getBookmarkedDocs();

    // Wait for both promises to resolve
    const bookmarkedDocs = await bookmarkedDocsPromise; // Array of bookmarked documents
    let queueCount = await queueCountPromise; // Array of queue counts by status

    queueCount.push({
      _id: docStatusMap.bookmarks,
      total: bookmarkedDocs.length,
    });

    setQueueCount(queueCount);
  };

  const handleClick = (index) => {
    setActive(index);
    setView(index);
    fetchQueueCount();
  };

  const items = navbarData.map((item, index) => (
    <>
      {['bookmarks'].includes(item.label.toLowerCase()) && <Divider my="xs" />}
      <NavLink
        key={item.label}
        active={index === active}
        label={item.label.toUpperCase()}
        description={item.description}
        rightSection={
          !hideDocCountsFrom.includes(item.label.toUpperCase()) ? (
            <Badge variant="light" size="sm" radius="xs" color="cyan">
              {queueCount.find((queue) => queue._id === item.status)?.total ||
                0}
            </Badge>
          ) : null
        }
        icon={<item.icon size={20} stroke={1.5} />}
        onClick={() => handleClick(index)}
        color="cyan"
        variant="filled"
      />
    </>
  ));

  return <Box>{items}</Box>;
}

export default NavBarItems;
